// Dependencies
import { FC } from "react";

// Styles
import {
  StyledNegativeAmount,
  StyledPositiveAmount,
} from "./TransactionAmount.styled";

interface TransactionAmountProps {
  children: string;
  sign: -1 | 1;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5";
}

const TransactionAmount: FC<TransactionAmountProps> = ({
  children,
  sign,
  variant,
}) => {
  if (sign === -1) {
    return (
      <StyledNegativeAmount variant={variant}>{children}</StyledNegativeAmount>
    );
  } else {
    return (
      <StyledPositiveAmount variant={variant}>{children}</StyledPositiveAmount>
    );
  }
};

export default TransactionAmount;
